import React from 'react';
import { Icon } from 'semantic-ui-react'

import TagsDropdown from '../tag_components/tags_dropdown';

import { stopEventPropagation } from '../../../helpers/event_helpers';

import './index.css';

export default function TraineeRole(props) {
  const { roleList, roleOptions, updateRoles, createNewRole, removeRole, updateTrainee, doneable, viewOnly } = props;

  return (
    <div className="trainee-role" onClick={stopEventPropagation}>
      {
        !viewOnly &&
        <TagsDropdown
          className="tags-dropdown roles-dropdown"
          trigger={<span className="link darkviolet">Role:</span>}
          header="Assign roles:"
          tagList={roleList}
          onApply={updateRoles}
          tagOptions={roleOptions}
          onNewTag={createNewRole}
          addable={true}
          searchable={true}
          searchPlaceholder="Search roles"
          newPlaceholder="Enter new role"
          onDone={updateTrainee}
          doneable={doneable}
        />
      }
      <span className='trainee-roles'>
        {
          roleList.map((role, index)=>{
            return (
              <span className='role' key={role} value={role}>
                {role} { !viewOnly && <Icon name='close' value={role} onClick={evt => removeRole(evt, role)}/>}
                {
                  index !== roleList.length - 1 && <span> , </span>
                }
              </span>
            )
          })
        }
      </span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/role_components/trainee_role.js